import { render, staticRenderFns } from "./editStakeholder.vue?vue&type=template&id=3dbea807&scoped=true&"
import script from "./editStakeholder.vue?vue&type=script&lang=js&"
export * from "./editStakeholder.vue?vue&type=script&lang=js&"
import style0 from "./editStakeholder.vue?vue&type=style&index=0&id=3dbea807&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dbea807",
  null
  
)

export default component.exports